import React, { useEffect, useState, useMemo } from "react";

// framework and libarry
import { Row, Col, Card, Form, Table, Button, Badge } from "react-bootstrap";
import moment from "moment";
import { useLazyQuery, useMutation } from "@apollo/client";

// components
import { COLOR_TEXT, COLOR_WHITE } from "../../../constants";
import { APPROVING_INVOICES_CREDIT_V2 } from "../../../graphql/wallet/mutation";
import ModalConfirmComponent from "../../../components/ModalConfirmComponent";
import LoadingSpinner from "../../../components/LoadingSpinner";
import CurrentDateModal from "../../../components/currentComponent/CurrentDateModal";
import { convertCurrentDate, numberFormat, splitDateTime } from "../../../helpers";
import { errorSwal, successSwal } from "../../../helpers/sweetalert";
import { GET_TRANSACTIONS } from "../../../graphql/wallet/query";
import PaginationHelper from "../../../helpers/PaginationHelper";

import "../../../styles/claimTable.css";

//  icons 
import { MdAdd, MdDateRange } from "react-icons/md";
import _ from "lodash";
import EmptyCredit from "./EmptyCredit";
import { GET_BANKS } from "../../../graphql/bank/query";



export default function ClaimCredit() {

  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  const [creditDatas, setCreditDatas] = useState({
    data: [],
    chartDatas: [],
    total: 0,
    credited: 0,
    receivedMoney: 0,
  });
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: "",
    createdAt_lt: "",
  });
  const [paymentMethod, setPaymentMethod] = useState({
    origin: '',
    status: '',
  })
  const [selectedItems, setSelectedItems] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmAll, setShowConfirmAll] = useState(false);
  let _shopId = localStorage.getItem("SHOP");
  const [dataNotClaims, setDataNotClaims] = useState([]);
  const [findDataStatus, setFindDataStatus] = useState([]);
  const [oldData, setOldData] = useState([]);
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [isNewFect, setIsNewFect] = useState(false);
  const [activeButton, setActiveButton] = useState("today");
  const [remark, setRemark] = useState()
  const [bankShopData, setBankShopData] = useState()
  const [billStatusCheck, setBillStatusCheck] = useState(false)
  const [totalNoClaims, setTotalNoClaims] = useState(0);
  const sp_cdc = JSON.parse(localStorage.getItem("SHOP_DATA"))?.sp_cdc || false;
  const [isCardFilter, setIsCardFilter] = useState("NORMAL");
  const amountSelect = useMemo(() => {
    const count = selectedItems.length;
    if (!count) return {
      count: 0,
      amount: 0, 
      color: "",
      status: false,
      msg: "",
    };
    
    // Calculate total amount
    const amount = selectedItems.reduce((total, item) => total + item?.amount, 0);
    
    // Group items by currency type and calculate total for each currency
    const LAK_BANKS = ["LDB", "JDB", "BCEL", "APB", "BFL","INDOCHINA_BANK"];
    const currencyGroups = {
      USD: 0,  // CREDIT_CARD
      LAK: 0,  // LDB, JDB, BCEL, APB, BFL
      THB: 0   // Others
    };
    
    selectedItems.forEach(item => {
      const origin = item?.origin;
      const itemAmount = item?.amount || 0;
      
      if (origin === "CREDIT_CARD") {
        currencyGroups.USD += itemAmount;
      } else if (LAK_BANKS.includes(origin)) {
        currencyGroups.LAK += itemAmount;
      } else if (origin) {
        currencyGroups.THB += itemAmount;
      }
    });
    
    // Check minimum amount for each currency group
    const invalidCurrencies = [];
    if (currencyGroups.USD > 0 && currencyGroups.USD < 0.1) {
      invalidCurrencies.push("USD");
    }
    if (currencyGroups.LAK > 0 && currencyGroups.LAK < 10000) {
      invalidCurrencies.push("LAK");
    }
    if (currencyGroups.THB > 0 && currencyGroups.THB < 20) {
      invalidCurrencies.push("THB");
    }
    
    const isValid = invalidCurrencies.length === 0;
    
    // Generate error message based on invalid currencies
    let errorMsg = "";
    if (!isValid) {
      // Check minimum amounts
      if (invalidCurrencies.includes("USD")) {
        errorMsg += `❌Credit Card ລວມ ${numberFormat(currencyGroups.USD.toFixed(2))} USD (ຕ້ອງ >= 0.1 USD) `;
      }
      if (invalidCurrencies.includes("LAK")) {
        errorMsg += `❌ລວມ ${numberFormat(currencyGroups.LAK)} ກີບ (ຕ້ອງ >= 10,000 ກີບ) `;
      }
      if (invalidCurrencies.includes("THB")) {
        errorMsg += `❌ລວມ ${numberFormat(currencyGroups.THB.toFixed(2))} ບາດ (ຕ້ອງ >= 20 ບາດ)`;
      }
    }
    
    // Determine currency label based on selected items
    let currencyLabel = "";
    let displayAmount = amount;
    if (currencyGroups.USD > 0) {
      currencyLabel = "USD";
      displayAmount = currencyGroups.USD;
    } else if (currencyGroups.LAK > 0) {
      currencyLabel = "LAK";
      displayAmount = currencyGroups.LAK;
    } else if (currencyGroups.THB > 0) {
      currencyLabel = "THB";
      displayAmount = currencyGroups.THB;
    }
    
    return {
      count,
      amount,
      displayAmount,
      currencyLabel,
      color: isValid ? "green" : "red",
      status: isValid,
      msg: isValid ? "♻️ເຄມເງິນ" : errorMsg || "❌ບໍ່ສາມາດເຄມເງີນໄດ້",
    };
  }, [selectedItems]);

  // apollo client libarry
  const [createInvoiceCredit, { loading: loadingCreateCredit }] = useMutation(APPROVING_INVOICES_CREDIT_V2);
  const [getAllTransactions, { data: transactionData, loading: loadingTransaction },] = useLazyQuery(GET_TRANSACTIONS, { fetchPolicy: "cache-and-network" });
  const [getBankData, { data: bankData, loading: loadingBank }] = useLazyQuery(GET_BANKS, { fetchPolicy: "cache-and-network", });

  // useEffect Hook
  useEffect(() => {
    if (transactionData) {
      setCreditDatas({
        data: transactionData?.getAllTransactions?.data,
        total: transactionData?.getAllTransactions?.total,
        credited: transactionData?.getAllTransactions?.reports?.credited,
        receivedMoney: transactionData?.getAllTransactions?.reports?.receivedMoney,
        totalPaidCompleted: transactionData?.getAllTransactions?.reports?.totalPaidCompleted,
        chartDatas: transactionData?.getAllTransactions?.reports?.chartDatas,
        origin: transactionData?.getAllTransactions?.reports?.chartDatas?.origin,
      });
    }
  }, [transactionData]);


  useEffect(() => {
    if (creditDatas?.chartDatas) {
      
      // Items that aren't approved
      const _newDatas = creditDatas.chartDatas.filter((data) => data?.billStatus !== "APPROVED");
      
      // Filter data based on selected items' origin if there are selected items
      let filteredChartDatas = creditDatas.chartDatas;
      
      if (selectedItems.length > 0) {
        const LAK_BANKS = ["LDB", "JDB", "BCEL", "APB", "BFL", "INDOCHINA_BANK_BANK"];
        const firstSelectedOrigin = selectedItems[0]?.origin;
        
        // Determine the group of first selected item
        const isSelectedCreditCard = firstSelectedOrigin === "CREDIT_CARD";
        const isSelectedLakBank = LAK_BANKS.includes(firstSelectedOrigin);
        
        // Filter data to match the selected origin group
        if (isSelectedCreditCard) {
          filteredChartDatas = creditDatas.chartDatas.filter(item => item?.origin === "CREDIT_CARD");
        } else if (isSelectedLakBank) {
          filteredChartDatas = creditDatas.chartDatas.filter(item => LAK_BANKS.includes(item?.origin));
        } else {
          // THB group - filter out CREDIT_CARD and LAK_BANKS
          filteredChartDatas = creditDatas.chartDatas.filter(item => 
            item?.origin !== "CREDIT_CARD" && !LAK_BANKS.includes(item?.origin)
          );
        }
      }
      
      const _newDatasTotal = filteredChartDatas.filter((data) => data?.billStatus === null);
      setTotalNoClaims(_newDatasTotal?.length)
      
      // Check if any item has billStatus === null (based on filtered data)
      const hasNullBillStatus = filteredChartDatas.some((data) => data?.billStatus === null);
      
      // Set billStatus to true if any item has null billStatus, otherwise set to false
      setBillStatusCheck(hasNullBillStatus);
      
      // Set other state values
      setDataNotClaims(_newDatas);
      setOldData(_newDatas);
    }
  }, [creditDatas?.chartDatas, selectedItems]);

  useEffect(() => {
    if (findDataStatus) {
      setDataNotClaims(findDataStatus);
    };
  }, [findDataStatus]);

  useEffect(() => {
    fetchTransactions();
  }, [isNewFect, paymentMethod, cdFillter, _skip, remark, isCardFilter]);

  useEffect(() => {
    _fetchBank(_shopId);
  }, [_shopId]);


  useEffect(() => {
    if (bankData) {
      setBankShopData(bankData?.banks?.data[0])
    }
  }, [bankData]);

  const _fetchBank = async (shopId) => {
    try {
      getBankData({
        variables: {
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  // function and logic this component
  const fetchTransactions = async () => {
    try {
      let shopId = localStorage.getItem("SHOP");

      if (loadingTransaction) return;
      let _where = {
        shopId: shopId, // "657fbca4741fcb028ebeec3f",
        // status: 'PAYMENT_COMPLETED'
      }

      // is origin or payment method
      if (!_.isEmpty(paymentMethod?.origin)) {
        _where = {
          ..._where,
          origin: paymentMethod?.origin,
        }
      }

      // is remark
      if (!_.isEmpty(remark)) {
        _where = {
          ..._where,
          remark: remark,
        }
      }
      // is status
      if (!_.isEmpty(paymentMethod?.status)) {
        _where = {
          ..._where,
          status: paymentMethod?.status,
        }
      }
      // is current date
      if (!_.isEmpty(cdFillter)) {
        let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
        let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);
        _where = {
          ..._where,
          createdAt_gte: startDateComponents,
          createdAt_lt: endDateComponents,
        }
      }

      // is card filter - filter by origin
      if (!_.isEmpty(isCardFilter) && isCardFilter === "CREDIT_CARD") {
        _where = {
          ..._where,
          origin: "CREDIT_CARD",
        }
      }

      await getAllTransactions({
        variables: {
          where: _where,
          skip: (_skip - 1) * _limit,
          limit: _limit,
        },
      });
      // setCdFillter({
      //   createdAt_gte: '', createdAt_lt: ''
      // })
    } catch (error) {
      console.log(error);
    }
  };

  // create invoice crediting
  const handleCreateInvoiceCredit = async () => {
    let shopId = localStorage.getItem("SHOP");
    
    try {
      if (loadingCreateCredit) return;
      const response = await createInvoiceCredit({
        variables: {
          where: {
            shopId: shopId,
          },
          data: {
            payments: JSON.stringify(selectedItems),
          },
        },
      });
      if(response?.data?.approvedInvoiceClaimCreditV2?.status === false) {
        errorSwal(response?.data?.approvedInvoiceClaimCreditV2?.msg);
        return
      }
      if (response?.data?.approvedInvoiceClaimCreditV2?.status === true) {
        setShowConfirm(false);
        setSelectedItems([]);
        setIsNewFect(true);
        successSwal(response?.data?.approvedInvoiceClaimCreditV2?.msg);
      }

    } catch (error) {
      setShowConfirm(false);
      console.log("error:", error);
      if (error.message === "BANK_ACCOUNT_NOT_FOUND") {
        errorSwal("ບໍ່ມີບັນຊີທະນາຄານ active ກະລຸນາເລືອກບັນຊີທະນາຄານຢູ່ຕັ້ງຄ່າກ່ອນ!")
        return
      }
      errorSwal("ເກີດຂໍ້ຜິດພາດທີ່ບໍ່ຄາດຄິດ")
    }
  };

  const handleCreateInvoicesAll = async () => {
    let shopId = localStorage.getItem("SHOP");

    try {
      if (loadingCreateCredit) return;
      
      // Get all completed items first
      let _allCompletedItems = dataNotClaims.filter(item => _.isEmpty(item?.bill) && item?.billStatus !== "APPROVED") || [];
      
      // If there are selected items, filter by origin based on selected items
      if (selectedItems.length > 0) {
        const LAK_BANKS = ["LDB", "JDB", "BCEL", "APB", "BFL", "INDOCHINA_BANK"];
        const firstSelectedOrigin = selectedItems[0]?.origin;
        
        // Determine the group of first selected item
        const isSelectedCreditCard = firstSelectedOrigin === "CREDIT_CARD";
        const isSelectedLakBank = LAK_BANKS.includes(firstSelectedOrigin);
        
        // Filter all completed items to match the selected origin group
        if (isSelectedCreditCard) {
          _allCompletedItems = _allCompletedItems.filter(item => item?.origin === "CREDIT_CARD");
        } else if (isSelectedLakBank) {
          _allCompletedItems = _allCompletedItems.filter(item => LAK_BANKS.includes(item?.origin));
        } else {
          // THB group - filter out CREDIT_CARD and LAK_BANKS
          _allCompletedItems = _allCompletedItems.filter(item => 
            item?.origin !== "CREDIT_CARD" && !LAK_BANKS.includes(item?.origin)
          );
        }
      }
      
      const response = await createInvoiceCredit({
        variables: {
          where: {
            shopId: shopId,
          },
          data: {
            payments: JSON.stringify(_allCompletedItems),
          },
        },
      });
      if(response?.data?.approvedInvoiceClaimCreditV2?.status === false) {
        errorSwal(response?.data?.approvedInvoiceClaimCreditV2?.msg);
        return
      }
      if (response?.data?.approvedInvoiceClaimCreditV2?.status === true) {
        setShowConfirm(false);
        setSelectedItems([]);
        setIsNewFect(true);
        setShowConfirmAll(false)
        successSwal(response?.data?.approvedInvoiceClaimCreditV2?.msg);
      }
      // if (response) {
      //   setShowConfirm(false);
      //   setShowConfirmAll(false)
      //   setSelectedItems([]);
      //   setIsNewFect(true);
      // }

    } catch (error) {
      setShowConfirmAll(false)
      console.log("error:", error);
      if (error.message === "BANK_ACCOUNT_NOT_FOUND") {
        errorSwal("ບໍ່ມີບັນຊີທະນາຄານ active ກະລຸນາເລືອກບັນຊີທະນາຄານຢູ່ຕັ້ງຄ່າກ່ອນ!")
        return
      }
      errorSwal("ເກີດຂໍ້ຜິດພາດ")
    }
  };

  // Handle select all
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      let allCompletedItems = dataNotClaims.filter(
        item => (
          _.isEmpty(item?.bill) && item?.billStatus !== "APPROVED"
          && !item?.isMerchantIdPayment && !item?.isAffialiatePayment
        )
      ) || [];
      
      // Filter by origin of the first item if it exists
      if (allCompletedItems.length > 0 && allCompletedItems[0]?.origin) {
        const LAK_BANKS = ["LDB", "JDB", "BCEL", "APB", "BFL", "INDOCHINA_BANK"];
        const firstItemOrigin = allCompletedItems[0].origin;
        
        // Filter by origin group
        if (firstItemOrigin === "CREDIT_CARD") {
          allCompletedItems = allCompletedItems.filter(item => item?.origin === "CREDIT_CARD");
        } else if (LAK_BANKS.includes(firstItemOrigin)) {
          allCompletedItems = allCompletedItems.filter(item => LAK_BANKS.includes(item?.origin));
        } else {
          // For other origins (THB), filter by exact origin match
          allCompletedItems = allCompletedItems.filter(item => item?.origin === firstItemOrigin);
        }
      }
      
      setSelectedItems(allCompletedItems);
    } else {
      setSelectedItems([]);
    }
  };

  // Handle select single
  const handleSelectSingle = (event, item) => {
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((selectedItem) => selectedItem._id !== item._id)
      );
    }
  };


  // select payment method
  const onSelectPaymentMethod = (e) => {
    let _values = e?.target?.value;
    setPaymentMethod({
      origin: _values
    });
  };

  const setNewDataByStatus = ({ data, status }) => {
    const newData = [];
    data.forEach(element => {
      if (element.isClaim === status) {
        newData.push(element);
      };
      setFindDataStatus(newData);
    });
  };
  const setNewDataNoClaim = ({ data }) => {
    const newData = [];
    data.forEach(element => {
      if (_.isEmpty(element.isClaim)) {
        newData.push(element);
      };
      setFindDataStatus(newData);
    });
  };

  // select origin
  const onSelectStatusPayment = (e) => {
    let _values = e?.target?.value;
    switch (_values) {
      case "CREATED":
      case "APPROVING":
        setNewDataByStatus({ data: oldData, status: _values });
        break;
      case "NO_CLAIM":
        setNewDataNoClaim({ data: oldData });
        break;
      case "":
        setFindDataStatus(oldData);
        break;
      default:
        setPaymentMethod({ status: _values });
        break;
    }
  };

  // select isCard filter - filter by origin
  const onSelectIsCard = (e) => {
    let _values = e?.target?.value;
    setIsCardFilter(_values);
    
    if (_values === "NORMAL" || _values === "") {
      // Show all data
      setFindDataStatus(oldData);
    } else if (_values === "CREDIT_CARD") {
      // Filter data based on origin
      const filteredData = oldData.filter(item => {
        return item?.origin === "CREDIT_CARD";
      });
      setFindDataStatus(filteredData);
    }
  };


  return (
    <>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ຊອກຫາລະຫັດອໍເດີ້</Form.Label>
            <Form.Control value={remark} type="text" onChange={(e) => setRemark(e?.target?.value)} placeholder="ORD-000-00000" />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ວັນທີ,ເດືອນ,ປີ</Form.Label>
            <Button
              variant="outline-secondary"
              onClick={() => setIsCurrentModals(true)}
              style={{ width: "100%", maxWidth: 230, display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

            >
              <MdDateRange style={{ fontSize: 25, color: COLOR_TEXT }} />
              {cdFillter?.createdAt_gte === "" && cdFillter?.createdAt_lt === "" ? (
                "mm/dd/yyyy"
              ) : (
                <>
                  {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                </>
              )}
            </Button>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ສະຖານະບິນ</Form.Label>
            <Form.Select
              onChange={(e) => onSelectStatusPayment(e)}
              aria-label="Default select example"
            >
              <option value="">--ເລືອກທັງໝົດ--</option>
              {/* <option value="PAYMENT_COMPLETED">ຊຳລະສຳເລັດ</option>
              <option value="NO_STATUS">ຍົກເລີກການຊຳລະ</option> */}
              <option value="CREATED">ລໍຖ້າດຳເນີນການ</option>
              <option value="APPROVING">ກຳລັງອະນຸມັດ</option>
              <option value="NO_CLAIM">ຍັງບໍ່ເຄມ</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ປະເພດການຊຳລະ</Form.Label>
            <Form.Select
              onChange={(e) => onSelectPaymentMethod(e)}
              aria-label="Default select example"
            >
              <option value="">--ເລືອກທັງໝົດ--</option>
              <option value="CREDIT_CARD">Credit Card</option>
              <option value="BCEL">BCEL One</option>
              <option value="JDB">JDB</option>
              <option value="LDB">LDB</option>
              <option value="INDOCHINA_BANK">INDOCHINA_BANK</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={1}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ບັດ</Form.Label>
            <Form.Select
              onChange={(e) => onSelectIsCard(e)}
              aria-label="Default select example"
              value={isCardFilter}
              // disabled={!isCard}
            >
              {/* <option value="">--ທັງໝົດ--</option> */}
              <option value="CREDIT_CARD">Credit Card</option>
              <option selected value="NORMAL">Normal</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Card
        className="mb-4"
        style={{ boxShadow: "none", background: COLOR_WHITE }}
      >
        <Card.Body>
          <Card.Title>
            <Row className="g-3 align-items-center">
              <Col xs={12} md={4} className="mb-2 mb-md-0">
                <h5 className="mb-0">ລາຍການທັງໝົດ {dataNotClaims.length ?? 0}</h5>
              </Col>
              {amountSelect.count > 0 && (<Col xs={12} md={4} className="mb-2 mb-md-0" style={{ color: amountSelect.color }}>
                <p className="mb-0 small">
                  ຈຳນວນລາຍການທີ່ເລືອກ {amountSelect.count}
                  <br className="d-md-none" />
                  <span className="ms-md-2">
                    {amountSelect.currencyLabel && (
                      <>
                        ລວມເປັນເງິນ {
                          amountSelect.currencyLabel === "LAK" 
                            ? numberFormat(amountSelect.displayAmount)
                            : amountSelect.displayAmount.toFixed(2)
                        } {amountSelect.currencyLabel} 
                      </>
                    )}
                    {amountSelect.msg}
                  </span>
                </p>
              </Col>)}
              {(billStatusCheck && amountSelect.status) && (
                <Col xs={12} md={4} className="d-flex flex-column flex-md-row justify-content-md-end gap-2">
                  <Button 
                    variant="success" 
                    onClick={() => setShowConfirmAll(true)}
                    className="mb-2 mb-md-0"
                  >
                    ເຄມເງິນທັງໝົດ {totalNoClaims} ອໍເດີ້
                  </Button>
                  <Button
                    disabled={!selectedItems?.length}
                    variant={selectedItems?.length ? "info" : "outline-info"}
                    onClick={() => setShowConfirm(true)}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <MdAdd className="me-1" />
                    <span>ສ້າງບິນ</span>
                    <span className="d-none d-md-inline">ເພື່ອຂໍເຄມເງິນ</span>
                  </Button>
                </Col>
              )}
            </Row>
          </Card.Title>
          {loadingTransaction ? (
            <LoadingSpinner />
          ) : (
            <>
              <div className="claim-responsive-table">
              <Table>
                <thead style={{ borderBottom: "none" }}>
                  <tr>
                    <th>
                      {/* Select all items */}
                      <Form.Check
                        type="checkbox"
                        id="ລຳດັບ"
                        label="ລຳດັບ"
                        onChange={handleSelectAll}
                        checked={
                          selectedItems?.length
                        }
                      />
                    </th>
                    <th>ລະຫັດອໍເດີ້</th>
                    <th>ຈຳນວນເງິນ</th>
                    <th>ທະນາຄານ</th>
                    <th>ວັນທີ,ເດືອນ,ປີ</th>
                    <th>ອໍເດີ</th>
                    <th>ສະຖານະບິນ</th>
                    <th>ໝາຍເຫດ</th>
                  </tr>
                </thead>
                <tbody>

                  {dataNotClaims?.length > 0 ? (

                    <>
                      {(() => {
                        // Filter data based on selected items' origin
                        let filteredData = dataNotClaims;
                        
                        if (selectedItems.length > 0) {
                          const LAK_BANKS = ["LDB", "JDB", "BCEL", "APB", "BFL", "INDOCHINA_BANK"];
                          const firstSelectedOrigin = selectedItems[0]?.origin;
                          
                          // Determine the group of first selected item
                          const isSelectedCreditCard = firstSelectedOrigin === "CREDIT_CARD";
                          const isSelectedLakBank = LAK_BANKS.includes(firstSelectedOrigin);
                          
                          // Filter data to show only items from the same origin group
                          filteredData = dataNotClaims.filter((item) => {
                            const itemOrigin = item?.origin;
                            const isItemCreditCard = itemOrigin === "CREDIT_CARD";
                            const isItemLakBank = LAK_BANKS.includes(itemOrigin);
                            
                            if (isSelectedCreditCard) {
                              return isItemCreditCard;
                            } else if (isSelectedLakBank) {
                              return isItemLakBank;
                            } else {
                              // THB group
                              return !isItemCreditCard && !isItemLakBank;
                            }
                          });
                        }
                        
                        return filteredData;
                      })().map((item, index) => {

                        // check item is claim _id, status, billNo
                        let bill = null;
                        if (item?.bill && typeof item?.bill === "string") {
                            bill = JSON.parse(item?.bill || "{}");
                        }

                        // check isAffialiatePayment or isMerchantIdPayment
                        const disabledItem = item?.isAffialiatePayment || item?.isMerchantIdPayment || bill?._id;

                        return (
                          <tr
                            key={index + 1 + _limit * (_skip - 1)}
                            style={{
                              background: item?.billStatus === "REQUESTING"
                                ? "#f1f1f1"
                                : item?.billStatus === "REQUESTING"
                                  ? "#fff"
                                  : "#fff",
                            }}
                          >
                            <td>
                              {/* Select single item */}
                              {item?.billStatus === "REQUESTING" ? (
                                <Form.Check
                                  type="checkbox"
                                  id={`item-${index}`}
                                  label={index + 1 + _limit * (_skip - 1)}
                                  disabled
                                />
                              ) : (
                                <Form.Check
                                  type="checkbox"
                                  id={`item-${index}`}
                                  label={index + 1 + _limit * (_skip - 1)}
                                  onChange={(e) => handleSelectSingle(e, item)}
                                  checked={selectedItems.some((selectedItem) => selectedItem._id === item._id)}
                                  disabled={disabledItem}
                                />
                              )}
                            </td>
                            <td>
                              {item?.remark ?? "-"}
                            </td>
                            <td>{numberFormat(item?.amount) ?? 0}</td>
                            <td>{item?.origin ?? "-"}</td>
                            {/* <td>-</td> */}
                            <td>
                              {moment(item?.createdAt).format("DD/MM/YYYY : HH:mm")}
                            </td>
                            <td>
                              {(
                                <p>
                                  {item?.isAffialiatePayment ? (
                                    <Badge pill bg="danger">ອໍເດີ ອາຟຣິລີເອດ</Badge> // ສ້າງ ຂໍເຄມສຳເລັດ
                                  ) : item?.isMerchantIdPayment ? (
                                    <Badge pill bg="success">ເງີນເຂົ້າບັນຊີໂດຍຕົງ</Badge>
                                  ) : typeof item?.bill === "string" ? (
                                    <Badge pill bg="info">{JSON.parse(item?.bill)?.status}</Badge> // ກຳລັງດຳເນີນການ
                                  ) : (
                                    <Badge pill bg="warning">ອໍເດີເຊວເພສ</Badge>
                                  )}
                                </p>
                              )}
                            </td>
                            <td>
                              {_.isEmpty(item?.isClaim) ? (
                                <p>
                                  <Badge pill bg="primary">ຍັງບໍ່ເຄມ</Badge>
                                </p>
                              ) : (
                                <p>
                                  {item?.isClaim === "CREATED" ? (
                                    <Badge pill bg="warning">ລໍຖ້າດຳເນີນການ</Badge> // ສ້າງ ຂໍເຄມສຳເລັດ
                                  ) : item?.isClaim === "FINISHED" ? (
                                    <Badge pill bg="success">ສຳເລັດທຸລະກຳ</Badge>
                                  ) : item?.isClaim === "APPROVING" ? (
                                    <Badge pill bg="info">ກຳລັງອະນຸມັດ</Badge> // ກຳລັງດຳເນີນການ
                                  ) : (
                                    <Badge pill bg="danger">ກະລຸນາກວດສອບ</Badge>
                                  )}
                                </p>
                              )}
                            </td>
  
                            <td>
                              {item?.bill !== null || item?.billStatus === "REQUESTING" ? (
                                <p>
                                  ຂໍເຄມເງິນແລ້ວ
                                </p>
                              ) : (
                                ""
                              )}
                            </td>
  
                          </tr>
                        )
                        })
                      }
                    </>

                  ) : (
                    <>
                      <EmptyCredit colSpan={7} />
                    </>
                  )}
                </tbody>
              </Table>
              </div>
              {/* <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {creditDatas?.total > 0 &&
                  Pagination_helper(creditDatas?.total, "/wallet_store", ``)}
              </div> */}
            </>
          )}
        </Card.Body>
      </Card >

      {/* modal confirm all */}
      < ModalConfirmComponent
        showConfirmModal={showConfirmAll}
        handleCancel={() => setShowConfirmAll(false)
        }
        loadingConfirm={loadingCreateCredit}
        handleConfirm={handleCreateInvoicesAll}
        title="ທ່ານໝັ້ນໃຈແລ້ວບໍ"
        text={`⚠️ກະລຸນາກວດສອບການຕັ້ງຄ່າບັນຊີທະນາຄານ ກ່ອນການເຄມເງີນ. ອໍເດີທີ່ເຄມເງີນຈະບໍ່ສາມມາດຍົກເລີກໄດ້⚠️. ຈຳນວນ ${dataNotClaims.filter(item => _.isEmpty(item?.bill) && item?.billStatus !== "APPROVED")?.length || 0} ອໍເດີ. ♻️ທ່ານຕ້ອງການຖອນເງິນທັງໝົດແທ້ບໍ♻️♻️!`}
      />

      {/* modal confirm create */}
      < ModalConfirmComponent
        showConfirmModal={showConfirm}
        handleCancel={() => setShowConfirm(false)
        }
        loadingConfirm={loadingCreateCredit}
        handleConfirm={handleCreateInvoiceCredit}
        title="ຢືນຢັນ ເພື່ອໃຫ້ແນ່ໃຈ!"
        text={`⚠️ກະລຸນາກວດສອບການຕັ້ງຄ່າບັນຊີທະນາຄານ ກ່ອນການເຄມເງີນ. ອໍເດີທີ່ເຄມເງີນຈະບໍ່ສາມມາດຍົກເລີກໄດ້⚠️. ຈຳນວນ ${selectedItems?.length} ອໍເດີ. ♻️ທ່ານຕ້ອງການສ້າງ ໃບແຈ້ງຖອນໃນຄັ້ງນີ້ແທ້ບໍ♻️!`}
      />

      {/* modal current date  */}
      < CurrentDateModal
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
        backdrop={true}

      />
    </>
  );
}
